module.exports = __webpack_public_path__ + "img/20220412.14175127.png";